import React, { useState } from "react";

import { useVitals } from "../Hooks/useVitals";
import { Vitals } from "../../../components/MedicalRecords/Vitals";
import { AuditModal } from "../../../components/AuditTrail/AuditModal";
import { AuditTrail } from "../../Admin/AuditTrail";
import { useTranslation } from "react-i18next";
import { ExpandableContent } from "../../../components/CustomControls/ExpandableContent";
import { ModalVitalsHistory } from "../Modals/ModalVitalsHistory";

export const VitalsListContainer = ({ entryId, medicalRecordNumber, mrn, expandedAll }) => {
    const { t } = useTranslation();
    const [data, query, totalSize, isLoading, handleTableChange] = useVitals(medicalRecordNumber, entryId);

    const [modal, setModal] = useState(null);
    const handleAuditTrail = (entityId) => {
        setModal(
            <AuditModal
                onClose={() => { setModal(null); }}
                title={t("auditTrail.audit")}
            >
                <AuditTrail entity="Vitals" entityId={entityId} medicalRecordNumber={medicalRecordNumber} />
            </AuditModal>
        )
    }

    const handleHistory = () => {
        setModal(<ModalVitalsHistory
            onClose={() => { setModal(null); }}
            title={t("medicalRecords.history.history")}
            medicalRecordNumber={medicalRecordNumber || mrn}
        />)
    }

    if (entryId && totalSize === 0)
        return null;
    
    return (
        <ExpandableContent title={t("medicalRecords.vitals.title")} content="vitals" expandedAll={expandedAll}>
            {modal}
            <Vitals
                withCard={false}
                data={data}
                query={query}
                totalSize={totalSize}
                isLoading={isLoading}
                onTableChange={handleTableChange}
                onAuditTrail={handleAuditTrail}
                onHistory={handleHistory}
            />
        </ExpandableContent>
    );
}